import { render, staticRenderFns } from "./DialogSelectLimit.vue?vue&type=template&id=66a65a10&"
import script from "./DialogSelectLimit.vue?vue&type=script&lang=js&"
export * from "./DialogSelectLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports